import moment from 'moment';

export const OCCURRENCE = 'occurence';
export const END_DATE = 'endDate';
export const FURTHER_NOTICE = 'furtherNotice';

/**
 * Returns type of complex end based on value given
 * @param value End Value provided to module
 * @returns {string}
 */
export const getComplexTypeByValue = (value) => (
  value
    ? moment.isMoment(value)
      ? END_DATE
      : OCCURRENCE
    : FURTHER_NOTICE
);
